export default "__VITE_ASSET__b0fac5c5__"